import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/ssl/fields';
import {useFieldData} from 'components/forms/hooks';
import {bootstrapOldForm} from 'components/forms/AutoSection';

const ShipmentDischarge = props => {
    const {schema, initialValues} = bootstrapOldForm(
        'ShipmentDischarge',
        fields
    );
    const [vesselName] = useFieldData('vessel_name', '', 'parent');

    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6' align='left'>
                Dates
            </Typography>
            <Typography variant='body1' align='left'>
                Now tell us about the dates you were on {vesselName}, positions
                you served, and routes you traveled on.
            </Typography>
            <Typography variant='body1' align='left'>
                {/* TODO: make this change based on how many passes you have made... */}
                Start by entering the dates for your first record on this
                vessel!
            </Typography>
            {[
                'date_reported',
                'place_reported',
                'date_detached',
                'place_detached',
                'authorized_12hr_days',
                'total_number_days',
            ].map(field => (
                <AutoField field={fields[field]} name={field} key={field} />
            ))}
            <Typography variant='body1' align='left'>
                Don't worry if you have several records on the same vessel on
                your letter - you'll have an opportunity to enter each one.
            </Typography>
            {props.children}
        </Section>
    );
};

export default ShipmentDischarge;
